import BaseView from '../base-view';
import TabbedView from '../components/tabbed-view/view';

export default BaseView.extend({
	events: {},

	initialize: function() {
		this.tabbedView = new TabbedView({
			el: '.js-tabs'
		});
	}
});
